module.exports = __webpack_public_path__ + "img/newstream.422dfa93.png";